var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCloseCircleRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z",
  fill: "#DF3038"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m8 8.527-2.536 2.537a.363.363 0 0 1-.261.106.354.354 0 0 1-.266-.107.359.359 0 0 1-.109-.263c0-.103.036-.191.109-.264L7.473 8 4.937 5.464a.363.363 0 0 1-.107-.262.354.354 0 0 1 .107-.265.36.36 0 0 1 .263-.11.36.36 0 0 1 .264.11L8 7.473l2.537-2.536a.363.363 0 0 1 .26-.107.354.354 0 0 1 .267.107.36.36 0 0 1 .108.263.36.36 0 0 1-.108.264L8.527 8l2.537 2.537c.069.069.104.156.106.26a.354.354 0 0 1-.106.266.36.36 0 0 1-.264.11.36.36 0 0 1-.263-.11L8 8.527Z",
  fill: "#fff"
})));

export default SvgCloseCircleRed;